module.exports = __webpack_public_path__ + "static/media/yandex.20017308.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/socials/yandex.svg
// module id = 213
// module chunks = 0